module.exports = __webpack_public_path__ + "img/pdf-icon.64b67053.svg";